import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import type { Schedule, SchedulePatch } from "../types";

interface PrnPanelProps {
  schedule: Schedule;
  onChange: (patch: SchedulePatch) => void;
}

export const PrnPanel: React.FC<PrnPanelProps> = ({ schedule, onChange }) => (
  <div className={styles.panel_column}>
    <span className={styles.prn_text}>Change when saturated, soiled, or dislodged.</span>
    <div className={styles.prn_row}>
      <label className={styles.prn_checkbox_label}>
        <input
          type="checkbox"
          checked={schedule.prnCap}
          onChange={() => onChange({ prnCap: !schedule.prnCap })}
        />
        But at least every
      </label>
      <div className={styles.stepper}>
        <button
          type="button"
          aria-label="Decrease"
          className={styles.stepper_btn}
          onClick={() => onChange({ prnMax: Math.max(1, schedule.prnMax - 1), prnCap: true })}
        >
          {"\u2212"}
        </button>
        <span className={styles.stepper_display}>{schedule.prnMax}</span>
        <button
          type="button"
          aria-label="Increase"
          className={styles.stepper_btn}
          onClick={() => onChange({ prnMax: Math.min(30, schedule.prnMax + 1), prnCap: true })}
        >
          +
        </button>
      </div>
      <span className={styles.panel_inline_label}>days</span>
    </div>
  </div>
);
